
import PostDataComplex from "../../services/PostDataComplex";

export default async function removeImageFromAlbum(imageId, idx, albumId) {
  
  const user = (JSON.parse(sessionStorage.userData)).user.usr_name;
  console.log(`user: ${user}`);
  const token = (JSON.parse(sessionStorage.userData)).user.token;
  console.log(`token: ${token}`);

  const data = {
    user: user,
    token: token,
    image_id: imageId,
    album_id: albumId,
  }

  let valueToReturn 

  await PostDataComplex('albums_manager', 'POST', 'removeFromFolder', data)
    .then((response) => {
      console.log('response.data:->');
      console.log(response.data);

      const removeFromFolder = response.data.feedBack.removeFromFolder.removeFromFolderResult;

      if(removeFromFolder.imageRemovedFromFolder) {
        console.log('images album association removed succesfully!!!');
        
        valueToReturn = idx
        
        
      } else {
        console.log(removeFromFolder.error);
        
        valueToReturn = -1
      }
    }
  )

  return valueToReturn


}